/**
 * 出勤規則（後端 attendanceService 同規則）：上班 09:00、遲到容許 10 分鐘、下班 18:00
 * 日期欄位存「選的日期」的 UTC 午夜，上下班時間存實際時刻（ISO）
 */
const LATE_AFTER_MINUTES = 9 * 60 + 10;
const LEAVE_BEFORE_MINUTES = 18 * 60;

const minutesOf = (value: Date) => value.getHours() * 60 + value.getMinutes();

interface AttendanceFlags {
  late: boolean;
  earlyLeave: boolean;
  missingCheckIn: boolean;
  missingCheckOut: boolean;
}

export const attendanceFlags = (record: { status?: string | null; checkInTime?: string | null; checkOutTime?: string | null }): AttendanceFlags => {
  const checkIn = record.checkInTime ? new Date(record.checkInTime) : null;
  const checkOut = record.checkOutTime ? new Date(record.checkOutTime) : null;
  return {
    late: !!checkIn && minutesOf(checkIn) > LATE_AFTER_MINUTES,
    earlyLeave: !!checkOut && minutesOf(checkOut) < LEAVE_BEFORE_MINUTES,
    missingCheckIn: record.status === 'PRESENT' && !checkIn,
    missingCheckOut: record.status === 'PRESENT' && !!checkIn && !checkOut,
  };
};

/** 本地日期 YYYY-MM-DD（toISOString 在 UTC+8 凌晨會變成前一天） */
export const ymd = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

/** 存在資料庫的日期 → 表單用 YYYY-MM-DD（用本地日期：UTC 午夜在台灣是當天 08:00；舊資料存的是台灣午夜） */
export const dateInputValue = (value?: string | null) => (value ? ymd(new Date(value)) : '');

/** 時刻 → 表單用 HH:mm（本地時間） */
export const timeInputValue = (value?: string | null) => {
  if (!value) return '';
  const date = new Date(value);
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
};

/** 表單的日期＋時間（本地時間）→ ISO；原本寫成 `${date}T${time}:00.000Z`，09:00 會被當成 UTC，畫面顯示成 17:00 */
export const toIsoDateTime = (date: string, time: string) => (time ? new Date(`${date}T${time}`).toISOString() : null);

/** 顯示時刻（HH:mm） */
export const formatTime = (value: string | null | undefined, locale: string) =>
  value ? new Date(value).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit', hour12: false }) : '';

/** 本月 1 日到今天（YYYY-MM-DD） */
export const thisMonthRange = () => {
  const now = new Date();
  return { startDate: ymd(new Date(now.getFullYear(), now.getMonth(), 1)), endDate: ymd(now) };
};
